import { useAuth } from "@/lib/auth-context";
import { useTheme } from "@/lib/theme-context";
import { getInitials } from "@/utils/initials-format";
import { RoleLabelsMap, RoleNome } from "@workflow/types";

function resolvePrimaryRoleLabel(roles: { nome: string }[] | undefined): string | null {
  if (!roles?.length) return null;

  const adminRole = roles.find((r) => r.nome === RoleNome.ADMIN);
  const primary = adminRole ?? roles[0];

  return RoleLabelsMap[primary.nome as RoleNome] ?? null;
}

export interface HeaderUser {
  displayName: string;
  firstName: string;
  initials: string;
  avatar: string | undefined;
  email: string;
  isAusente: boolean;
  roleLabel: string | null;
  verticaisCount: number;
  theme: string;
  toggleTheme: () => void;
  logout: () => void;
}

export function useHeaderUser(): HeaderUser {
  const { user, logout } = useAuth();
  const { theme, setTheme } = useTheme();

  const displayName = user?.nome ?? "Usuário";

  return {
    displayName,
    firstName: displayName.split(" ")[0],
    initials: user?.nome ? getInitials(user.nome) : "U",
    avatar: user?.fotoThumb ?? user?.foto,
    email: user?.email ?? "",
    isAusente: !!user?.ausente,
    roleLabel: resolvePrimaryRoleLabel(user?.roles),
    verticaisCount: user?.squads?.length ?? 0,
    theme,
    toggleTheme: () => setTheme(theme === "dark" ? "light" : "dark"),
    logout,
  };
}
